import { useState, useEffect } from "react";
import { useCart } from "./Founder/CartContext";
import { useNavigate } from "react-router-dom";
import { BASEAPIURL, token } from "../env";
import { getDateRange } from "./commonFunctionlity";

const LawnBooking = () => {
  // Step Management
  const [step, setStep] = useState(1);
  // Member Info
  const [memberId] = useState(sessionStorage.getItem("MemberID") || "");
  const [memberName] = useState(sessionStorage.getItem("MemberName") || "");
  const [memberMobile] = useState(sessionStorage.getItem("MemMobileNo") || "");
  // Step 1: Booking Criteria
  const [fromDate, setFromDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [toDate, setToDate] = useState("");
  const [bookingDates, setBookingDates] = useState([fromDate]);
  const [numPeople, setNumPeople] = useState(25);
  const [lawnTypes, setLawnTypes] = useState([]);
  const [selectedLawnType, setSelectedLawnType] = useState("");
  const [availableSlots, setAvailableSlots] = useState([]);
  const [selectedSlotTypes, setSelectedSlotTypes] = useState([]);
  const [selectedSundryItems, setSelectedSundryItems] = useState([]);
  // NEW: Track mandatory (non-optional) sundry items
  const [mandatorySundryItems, setMandatorySundryItems] = useState([]);
  // Availability
  const [isChecking, setIsChecking] = useState(false);
  const [availabilityResult, setAvailabilityResult] = useState(null);
  // Step 2: Guest Details
  const [guests, setGuests] = useState([]);
  const [dependents, setDependents] = useState([]);
  // Pricing
  const [lawnPrice, setLawnPrice] = useState(0);
  const [taxPercentage, setTaxPercentage] = useState(0);
  const [taxIncluded, setTaxIncluded] = useState(true);
  // Status
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [bookingStatus, setBookingStatus] = useState(null);
  const [bookingMessage, setBookingMessage] = useState("");
  // Sundry Items
  const [sundryTypes, setSundryTypes] = useState([]);
  const [sundryPrices, setSundryPrices] = useState({});

  const [slotError, setSlotError] = useState(null);

  // Auto-dismiss slot selection error
  useEffect(() => {
    if (slotError) {
      const timer = setTimeout(() => setSlotError(null), 10000);
      return () => clearTimeout(timer);
    }
  }, [slotError]);
  // Toast auto-dismiss
  useEffect(() => {
    if (bookingStatus) {
      const timer = setTimeout(() => {
        setBookingStatus(null);
        setBookingMessage("");
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [bookingStatus]);
  // Generate date range when dates change
  useEffect(() => {
    if (fromDate && toDate && fromDate <= toDate) {
      const startDate = new Date(fromDate);
      const endDate = new Date(toDate);
      const dates = [];
      const currentDate = new Date(startDate);
      while (currentDate <= endDate) {
        dates.push(currentDate.toISOString().split("T")[0]);
        currentDate.setDate(currentDate.getDate() + 1);
      }
      setBookingDates(dates);
    } else if (fromDate) {
      setBookingDates([fromDate]);
    }
  }, [fromDate, toDate]);
  // Fetch lawn types with effective date when fromDate changes
  useEffect(() => {
    fetchLawnTypes();
  }, [fromDate]);
  // When lawn type or guest details change
  useEffect(() => {
    if (selectedLawnType) {
      const selectedLawn = lawnTypes.find(
        (l) => String(l.Lawn_ID) === selectedLawnType
      );
      if (selectedLawn) {
        let price = 0;
        // Handle case where both prices are 0
        if (parseFloat(selectedLawn.GuestLawnPrice) > 0) {
          price =
            guests[0]?.bookingFor === "Guest"
              ? parseFloat(selectedLawn.GuestLawnPrice)
              : parseFloat(selectedLawn.MemberLawnPrice) || 0;
        } else if (parseFloat(selectedLawn.MemberLawnPrice) > 0) {
          price = parseFloat(selectedLawn.MemberLawnPrice);
        }
        setLawnPrice(price);
        setTaxPercentage(parseFloat(selectedLawn.TaxPercentage) || 0);
        setTaxIncluded(
          selectedLawn.TaxIsInclude === "True" ||
            selectedLawn.TaxIsInclude === true
        );
        setNumPeople(
          selectedLawn.LawnCapacity ? parseInt(selectedLawn.LawnCapacity) : 25
        );
      }
    }
  }, [selectedLawnType, lawnTypes, guests, numPeople]);
  // Initialize guests when moving to Step 2
  useEffect(() => {
    if (step === 2 && guests.length === 0) {
      setGuests([
        {
          id: 1,
          bookingFor: "Member",
          name: memberName,
          contact: memberMobile,
          dependentId: "",
        },
      ]);
    }
  }, [step, memberName, memberMobile]);
  // Fetch dependents
  useEffect(() => {
    if (step === 2 && memberId) {
      fetchDependents();
    }
  }, [step, memberId]);
  // API: Fetch Lawn Types with Effective Date
  const fetchLawnTypes = async () => {
    try {
      const effectiveDate = fromDate; // Using fromDate as effective date
      const res = await fetch(
        `${BASEAPIURL}/GetLawnspricelist?Type=Lawn&Token=${encodeURIComponent(
          token
        )}&EffectiveDate=${effectiveDate}`,
        { method: "GET", headers: { "Content-Type": "application/json" } }
      );
      const json = await res.json();
      if (
        (json.status === true || json.status === "true") &&
        Array.isArray(json.data)
      ) {
        setLawnTypes(json.data);
        if (json.data.length > 0 && !selectedLawnType) {
          setSelectedLawnType(String(json.data[0].Lawn_ID));
        }
      } else {
        setError("No lawns available.");
      }
    } catch (err) {
      setError("Failed to load lawns.");
      console.error("Lawn fetch error:", err);
    }
  };
  // API: Fetch Dependents
  const fetchDependents = async () => {
    try {
      const res = await fetch(
        `${BASEAPIURL}/DependentListByMemID?MemID=${memberId}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ tokenData: token }),
        }
      );
      const json = await res.json();
      if (Array.isArray(json.data)) {
        setDependents(json.data);
      }
    } catch (err) {
      setError("Failed to load dependents.");
    }
  };
  // API: Fetch Sundry Types with Prices
  const fetchSundryTypes = async (lawnTypeId) => {
    try {
      const res = await fetch(
        `${BASEAPIURL}/GetSundrybyLawntypeID?token=${token}&LawntypeID=${lawnTypeId}`,
        { method: "GET" }
      );
      const json = await res.json();
      if (Array.isArray(json.data)) {
        setSundryTypes(json.data);
        // Extract prices for quick lookup
        const prices = {};
        const mandatoryIds = [];
        json.data.forEach((sundry) => {
          prices[sundry.LTSundry_ID] = parseFloat(sundry.LTSundry_Amount) || 0;
          // According to requirement: if LTSundry_Optional is true → mandatory & locked
          if (
            sundry.LTSundry_Optional === true ||
            sundry.LTSundry_Optional === "True"
          ) {
            mandatoryIds.push(String(sundry.LTSundry_ID));
          }
        });
        setSundryPrices(prices);
        setMandatorySundryItems(mandatoryIds);

        // Auto-select mandatory items
        setSelectedSundryItems((prev) => {
          const newSet = new Set([...prev, ...mandatoryIds]);
          return Array.from(newSet);
        });
      } else {
        setSundryTypes([]);
        setSundryPrices({});
        setMandatorySundryItems([]);
      }
    } catch (err) {
      console.error("Sundry fetch error:", err);
      setSundryTypes([]);
      setSundryPrices({});
      setMandatorySundryItems([]);
    }
  };
  // Generate date range for multi-date selection
  const generateDateRange = (startDate, endDate) => {
    const dates = [];
    const currentDate = new Date(startDate);
    while (currentDate <= new Date(endDate)) {
      dates.push(currentDate.toISOString().split("T")[0]);
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return dates;
  };
  // Availability Check with Effective Date for Multiple Dates
  const handleAvailabilityCheck = async () => {
    if (!bookingDates.length || !selectedLawnType || numPeople < 1) {
      setError("No Booking available for these days.");
      return;
    }
    setIsChecking(true);
    setAvailabilityResult(null);
    setAvailableSlots([]);
    try {
      const effectiveDate = fromDate; // Using fromDate as effective date
      const availabilityPromises = bookingDates.map(async (date) => {
        const res = await fetch(
          `${BASEAPIURL}/GetLawnAvailability?EDate=${date}&Type=Lawn&LawnID=${selectedLawnType}&Token=${encodeURIComponent(
            token
          )}&EffectiveDate=${effectiveDate}`,
          { method: "GET" }
        );
        const json = await res.json();
        return { date, json };
      });
      const results = await Promise.all(availabilityPromises);
      // Check if any date has valid availability data
      const hasValidAvailability = results.some(
        (result) =>
          Array.isArray(result.json?.data) && result.json.data.length > 0
      );
      if (!hasValidAvailability) {
        setError(
          "No Lawn Booking Available On These Date Select Another Date."
        );
        setAvailabilityResult(null);
        setIsChecking(false);
        return;
      }
      const allAvailableSlots = results.map((result) => ({
        date: result.date,
        slots: Array.isArray(result.json?.data)
          ? result.json.data.filter((slot) => slot.Status === "Available")
          : [],
      }));
      // Check if we have available slots for all dates
      const allDatesHaveSlots = allAvailableSlots.every(
        (result) => result.slots.length > 0
      );
      if (allDatesHaveSlots) {
        const consolidatedSlots = allAvailableSlots[0].slots.filter((slot) =>
          allAvailableSlots.every((result) =>
            result.slots.some(
              (s) => s.Slot_ID === slot.Slot_ID && s.Status === "Available"
            )
          )
        );
        if (consolidatedSlots.length > 0) {
          setAvailableSlots(consolidatedSlots);
          setAvailabilityResult({ consolidated: true, dates: bookingDates });
          setSelectedSlotTypes([]);
          setSelectedSundryItems([]);
          // Fetch sundry types when availability is confirmed
          fetchSundryTypes(selectedLawnType);
          setError(null);
        } else {
          setError("No common slots available across all selected dates.");
          setAvailabilityResult(null);
        }
      } else {
        setError(
          "No Lawn Booking Available On These Date Select Another Date."
        );
        setAvailabilityResult(null);
      }
    } catch (err) {
      setError("Failed to check availability.");
      setAvailabilityResult(null);
    } finally {
      setIsChecking(false);
    }
  };
  // Handle Slot Selection
  const handleSlotSelect = (slotId) => {
    setSelectedSlotTypes((prev) =>
      prev.includes(slotId)
        ? prev.filter((id) => id !== slotId)
        : [...prev, slotId]
    );
  };
  // Handle Sundry Item Selection — BLOCK unchecking of mandatory items
  const handleSundrySelect = (sundryId) => {
    if (mandatorySundryItems.includes(sundryId)) {
      return; // Do nothing if trying to uncheck a mandatory item
    }
    setSelectedSundryItems((prev) =>
      prev.includes(sundryId)
        ? prev.filter((id) => id !== sundryId)
        : [...prev, sundryId]
    );
  };
  // Handle Guest Changes
  const handleGuestChange = (id, field, value) => {
    setGuests((prev) =>
      prev.map((g) => {
        if (g.id !== id) return g;
        let updates = { [field]: value };
        if (field === "bookingFor") {
          if (value === "Member") {
            updates.name = memberName;
            updates.contact = memberMobile;
            updates.dependentId = "";
          } else {
            updates.name = "";
            updates.contact = "";
            updates.dependentId = "";
          }
        }
        return { ...g, ...updates };
      })
    );
  };
  const handleDependentSelect = (id, depId) => {
    const dep = dependents.find((d) => String(d.DeptID) === depId);
    if (dep) {
      const contact = dep.Contact || dep.MobileNo || "";
      setGuests((prev) =>
        prev.map((g) =>
          g.id === id
            ? { ...g, dependentId: depId, name: dep.Name, contact: contact }
            : g
        )
      );
    }
  };
  // Validate Guests
  const validateGuests = () => {
    for (const g of guests) {
      if (!g.name?.trim()) return "Name is required.";
      if (g.bookingFor !== "Member" && !/^[6-9]\d{9}$/.test(g.contact)) {
        return `Valid 10-digit number required for ${g.name}.`;
      }
    }
    return null;
  };
  // Submit Booking with Effective Date
  const handleSubmitBooking = async () => {
    const error = validateGuests();
    if (error) {
      setError(error);
      return null;
    }
    if (!selectedSlotTypes.length && !selectedSundryItems.length) {
      setError("Please select at least one slot or sundry item.");
      return null;
    }
    setIsSubmitting(true);
    try {
      const effectiveDate = fromDate; // Using fromDate as effective date
      const selectedLawn = lawnTypes.find(
        (l) => String(l.Lawn_ID) === selectedLawnType
      );
      if (!selectedLawn) {
        setError("Selected lawn type not found.");
        return null;
      }
      const taxRate = taxPercentage / 100;
      const bookingDtl = [];

      // 🔹 Helper function for tax calculation
      const calculateRateAndGST = (amount, taxIncluded) => {
        let baseRate = amount;
        let gstAmount = 0;
        if (taxIncluded) {
          baseRate = amount / (1 + taxRate);
          gstAmount = amount - baseRate;
        } else {
          gstAmount = amount * taxRate;
        }
        return {
          bookingRate: Number(baseRate.toFixed(2)),
          gstAmount: Number(gstAmount.toFixed(2)),
        };
      };

      bookingDates.forEach((date) => {
        // ✅ Regular Slots
        selectedSlotTypes.forEach((slotId) => {
          const sundryItem = sundryTypes.find(
            (s) => String(s.LTSundry_ID) === slotId
          );
          let amount = 0;
          let slotName = "Unknown Slot";

          if (sundryItem) {
            // 🔸 Sundry as slot
            amount = parseFloat(sundryItem.LTSundry_Amount) || 0;
            slotName = sundryItem.LTSundry_Type || `Sundry ${slotId}`;
          } else {
            // 🔹 Regular Lawn Price
            const price =
              guests[0]?.bookingFor === "Guest"
                ? parseFloat(selectedLawn.GuestLawnPrice) ||
                  parseFloat(selectedLawn.MemberLawnPrice) ||
                  0
                : parseFloat(selectedLawn.MemberLawnPrice) || 0;
            amount = price;
            slotName =
              availableSlots.find((s) => String(s.Slot_ID) === slotId)
                ?.Slot_Name || `Slot ${slotId}`;
          }

          const { bookingRate, gstAmount } = calculateRateAndGST(
            amount,
            taxIncluded
          );

          bookingDtl.push({
            SlotID: parseInt(slotId),
            LawnID: parseInt(selectedLawnType),
            EventDate: date,
            BookingType: "Lawn",
            BookingRate: bookingRate,
            GSTAmount: gstAmount,
            Is_TaxInclude: taxIncluded,
            Slot_Name: slotName,
            SundryDtl: selectedSundryItems.map((id) => {
              const sundry = sundryTypes.find(
                (item) => String(item.LTSundry_ID) === id
              );
              return {
                SundryID: sundry?.LTSundry_SundryID,
                SundryName: sundry?.LTSundry_Name,
                SundryAmount: sundry?.LTSundry_Amount,
                EC_Sundry_ID: sundry?.LTSundry_EC_SundryID,
              };
            }),
          });
        });

        // ✅ Standalone Sundry Items (if needed)
        selectedSundryItems.forEach((sundryId) => {
          const sundryItem = sundryTypes.find(
            (s) => String(s.LTSundry_ID) === sundryId
          );
          if (sundryItem) {
            const { bookingRate, gstAmount } = calculateRateAndGST(
              parseFloat(sundryItem.LTSundry_Amount) || 0,
              taxIncluded
            );
          }
        });
      });

      // ✅ Totals
      const totalBookingAmount = Number(
        bookingDtl.reduce((sum, dtl) => sum + dtl.BookingRate, 0).toFixed(2)
      );
      const totalGSTAmount = Number(
        bookingDtl.reduce((sum, dtl) => sum + dtl.GSTAmount, 0).toFixed(2)
      );

      // ✅ Final Payload
      const bookingPayload = {
        tokenData: token,
        booking: {
          MemberID: parseInt(memberId),
          BookingFor: guests[0]?.bookingFor || "Member",
          GuestName: guests[0]?.name || memberName,
          GuestContact: guests[0]?.contact || memberMobile,
          MemberQuantity: numPeople,
          BookingPaymentStatus: "Pending",
          BookingAmount: totalBookingAmount,
          GSTAmount: totalGSTAmount,
          BookingDtl: bookingDtl,
        },
      };

      console.log("Sending Booking Payload:", bookingPayload);
      const bookingResponse = await fetch(
        `${BASEAPIURL}/InsertLawnBooking`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(bookingPayload),
        }
      );
      const bookingResult = await bookingResponse.json();
      if (bookingResult.data === true || bookingResult.data === "true") {
        setStep(1);
        setGuests([]);
        setAvailabilityResult(null);
        setFromDate(new Date().toISOString().split("T")[0]);
        setToDate("");
        setBookingDates([new Date().toISOString().split("T")[0]]);
        setNumPeople(25);
        setSelectedLawnType(lawnTypes[0]?.Lawn_ID || "");
        setSelectedSlotTypes([]);
        setSelectedSundryItems([]);
        setAvailableSlots([]);
        setSundryTypes([]);
        setSundryPrices({});
        setBookingStatus("success");
        setBookingMessage("Booking created successfully!");
        return bookingResult.BookingID || bookingResult.data.BookingID || null;
      } else {
        setError(
          "Booking failed: " + (bookingResult.message || "Unknown error")
        );
        console.error("Booking API Error:", bookingResult);
        return null;
      }
    } catch (err) {
      setError(err.message || "Something went wrong during booking.");
      console.error("Booking error:", err);
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };
  // Format Date
  const formatDate = (dateStr) => {
    return dateStr
      ? new Date(dateStr).toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
      : "N/A";
  };
  // Calculate Prices
  const calculatePrices = () => {
    const selectedLawn = lawnTypes.find(
      (l) => String(l.Lawn_ID) === selectedLawnType
    );
    if (!selectedLawn) return { base: 0, tax: 0, total: 0 };
    let price = 0;
    // Handle case where both prices are 0
    if (parseFloat(selectedLawn.GuestLawnPrice) > 0) {
      price =
        guests[0]?.bookingFor === "Guest"
          ? parseFloat(selectedLawn.GuestLawnPrice) ||
            parseFloat(selectedLawn.MemberLawnPrice) ||
            0
          : parseFloat(selectedLawn.MemberLawnPrice) || 0;
    } else if (parseFloat(selectedLawn.MemberLawnPrice) > 0) {
      price = parseFloat(selectedLawn.MemberLawnPrice) || 0;
    }
    // Apply guest multiplier to base price
    const basePriceWithGuests = price;
    let basePrice = basePriceWithGuests;
    let taxAmount = 0;
    if (taxIncluded) {
      basePrice = basePriceWithGuests / (1 + taxPercentage / 100);
      taxAmount = basePriceWithGuests - basePrice;
    } else {
      taxAmount = basePriceWithGuests * (taxPercentage / 100);
    }
    return {
      base: basePrice,
      tax: taxAmount,
      total: basePrice + taxAmount,
    };
  };
  // Calculate Total Price Including Sundry Items
  const calculateTotalPrice = () => {
    const basePrice = calculatePrices();
    let totalBase = basePrice.base;
    let totalTax = basePrice.tax;
    // Add sundry item prices
    selectedSlotTypes.forEach((slotId) => {
      const isSundryItem = sundryTypes.some(
        (s) => String(s.LTSundry_ID) === slotId
      );
      if (isSundryItem) {
        const sundryAmount = sundryPrices[slotId] || 0;
        totalBase += sundryAmount;
        if (taxIncluded) {
          const baseAmount = sundryAmount / (1 + taxPercentage / 100);
          const taxOnSundry = sundryAmount - baseAmount;
          totalTax += taxOnSundry;
        } else {
          totalTax += sundryAmount * (taxPercentage / 100);
        }
      }
    });
    // Add selected sundry items
    selectedSundryItems.forEach((sundryId) => {
      const sundryAmount = sundryPrices[sundryId] || 0;
      totalBase += sundryAmount;
      if (taxIncluded) {
        const baseAmount = sundryAmount / (1 + taxPercentage / 100);
        const taxOnSundry = sundryAmount - baseAmount;
        totalTax += taxOnSundry;
      } else {
        totalTax += sundryAmount * (taxPercentage / 100);
      }
    });
    return {
      base: totalBase,
      tax: totalTax,
      total: totalBase + totalTax,
    };
  };
  const selectedLawn = lawnTypes.find(
    (l) => String(l.Lawn_ID) === selectedLawnType
  );
  const selectedSlots = availableSlots.filter((s) =>
    selectedSlotTypes.includes(String(s.Slot_ID))
  );
  const prices = calculatePrices();
  const totalPrice = calculateTotalPrice();
  const GST_RATE = taxPercentage / 100;
  const { addToCart } = useCart();
  const navigate = useNavigate();
  
  const handleAddToCart = async () => {
    const bookingID = await handleSubmitBooking();
    if (!bookingID) {
      console.warn("No BookingID returned; cart not updated.");
      return;
    }
    const cartItems = bookingDates.map((date) => {
      const slots = selectedSlotTypes.map((slotId) => {
        const slot = availableSlots.find((s) => String(s.Slot_ID) === slotId);
        return {
          SlotID: parseInt(slotId),
          Slot_Name: slot?.Slot_Name || "N/A",
        };
      });
      const bookingDtl = selectedSlotTypes.map((slotId) => {
        const selectedLawn = lawnTypes.find(
          (l) => String(l.Lawn_ID) === selectedLawnType
        );
        let price = 0;
        // Check if this is a sundry item
        const isSundryItem = sundryTypes.some(
          (s) => String(s.LTSundry_ID) === slotId
        );
        if (isSundryItem) {
          // For sundry items, use the sundry amount
          price = sundryPrices[slotId] || 0;
        } else {
          // For regular slots, use lawn price multiplied by number of guests
          price =
            guests[0]?.bookingFor === "Guest"
              ? parseFloat(selectedLawn.GuestLawnPrice) ||
                parseFloat(selectedLawn.MemberLawnPrice) ||
                0
              : parseFloat(selectedLawn.MemberLawnPrice) || 0;
        }
        let bookingRate = price;
        let gstAmount = 0;
        if (taxIncluded) {
          bookingRate = price / (1 + taxPercentage / 100);
          gstAmount = price - bookingRate;
        } else {
          gstAmount = price * (taxPercentage / 100);
        }
        return {
          SlotID: parseInt(slotId),
          LawnID: parseInt(selectedLawnType),
          EventDate: date,
          BookingType: isSundryItem ? "Sundry" : "Lawn",
          BookingRate: bookingRate,
          GSTAmount: gstAmount,
          Is_TaxInclude: taxIncluded,
        };
      });
      return {
        type: "Lawn",
        apiType: "lawn",
        bookId: bookingID,
        details: {
          lawnName: selectedLawn?.Lawn_Name || "Unknown Lawn",
          date: date,
          slots: slots.map((s) => s.Slot_Name),
          guests: numPeople,
        },
        pricing: {
          base: totalPrice.base,
          tax: totalPrice.tax,
          total: totalPrice.total,
        },
        payload: {
          MemberID: parseInt(memberId),
          BookingFor: guests[0]?.bookingFor || "Member",
          GuestName: guests[0]?.name || "Guest",
          GuestContact: guests[0]?.contact || "",
          MemberQuantity: numPeople,
          EventDate: date,
          BookingDtl: bookingDtl,
          bookId: bookingID,
          Sundry_IDs: selectedSundryItems.map((id) => {
            const sundry = sundryTypes.find(
              (item) => String(item.LTSundry_ID) === id
            );
            return {
              LTSundry_ID: id,
              LTSundry_Amount: sundry?.LTSundry_Amount,
            };
          }),
        },
      };
    });
    const existingCart = localStorage.getItem("cart");
    let existingItems = existingCart ? JSON.parse(existingCart) : [];
    const newItems = cartItems.filter(
      (item) =>
        !existingItems.some(
          (existing) =>
            existing.type === "Lawn" &&
            existing.payload.LawnID === item.payload.BookingDtl[0]?.LawnID &&
            existing.payload.EventDate === item.payload.EventDate
        )
    );
    if (newItems.length === 0) {
      console.warn("All bookings already in cart.");
      return;
    }
    existingItems = [...existingItems, ...newItems];
    localStorage.setItem("cart", JSON.stringify(existingItems));
    navigate("/dashboard/cart");
  };
  useEffect(() => {
    localStorage.removeItem("cart");
  }, []);

   const { minDate, maxDate } = getDateRange(365);
    const { fromToMaxDate } = getDateRange(90, fromDate);

  return (
    <div className="container-fluid">
      <div className="row justify-content-center">
        <div className="col-12 col-md-10 col-lg-12">
          <div className="text-center mb-5">
            <h2 className="text-primary fw-bold mb-2">🌿 Lawn Booking</h2>
            <p className="text-muted">
              Plan your event with our premium lawn facilities
            </p>
          </div>
          {/* Alerts */}
          {bookingStatus === "success" && (
            <div
              className="alert alert-success alert-dismissible fade show mb-4"
              role="alert"
            >
              <i className="bi bi-check-circle-fill me-2"></i>
              {bookingMessage}
              <button
                type="button"
                className="btn-close"
                onClick={() => setBookingStatus(null)}
              ></button>
            </div>
          )}
          {error && (
            <div
              className="alert alert-danger alert-dismissible fade show mb-4"
              role="alert"
            >
              <i className="bi bi-exclamation-triangle-fill me-2"></i>
              {error}
              <button
                type="button"
                className="btn-close"
                onClick={() => setError(null)}
              ></button>
            </div>
          )}
          {/* Step 1: Availability */}
          {step === 1 && (
            <div className="card shadow-lg border-0 rounded-4 overflow-hidden">
              <div className="card-body p-4">
                {/* Form Row */}
                <div className="d-flex flex-wrap gap-3 align-items-end">
                  {/* From Date */}
                  <div className="flex-grow-1 min-w-0">
                    <label className="form-label fw-semibold">From Date</label>
                    <input
                      type="date"
                      className="form-control form-control-lg rounded-pill border-primary"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      min={minDate}
                      max={maxDate}
                    />
                  </div>
                  {/* To Date */}
                  <div className="flex-grow-1 min-w-0">
                    <label className="form-label fw-semibold">
                      To Date (Optional)
                    </label>
                    <input
                      type="date"
                      className="form-control form-control-lg rounded-pill border-primary"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                      min={fromDate || minDate}
                      max={fromToMaxDate}
                    />
                  </div>
                  {/* Lawn Type */}
                  <div className="flex-grow-1 min-w-0">
                    <label className="form-label fw-semibold">Lawn Type</label>
                    <select
                      className="form-select form-select-lg rounded-pill border-primary"
                      value={selectedLawnType}
                      onChange={(e) => setSelectedLawnType(e.target.value)}
                    >
                      <option value="">Select Lawn</option>
                      {lawnTypes.map((l) => (
                        <option key={l.Lawn_ID} value={l.Lawn_ID}>
                          {l.Lawn_Name}
                        </option>
                      ))}
                    </select>
                  </div>
                  {/* Guest Capacity */}
                  <div className="flex-grow-1 min-w-0">
                    <label className="form-label fw-semibold">
                      Guest Capacity
                    </label>
                    <input
                      type="number"
                      className="form-control form-control-lg rounded-pill border-primary"
                      value={numPeople}
                      onChange={(e) => {
                        const value = parseInt(e.target.value) || 1;
                        if (value >= 1) setNumPeople(value);
                      }}
                      min="25"
                      max={selectedLawn?.LawnCapacity || 100}
                    />
                  </div>
                  {/* Search Button */}
                  <div className="ms-auto mt-2">
                    <button
                      type="button"
                      className="btn btn-warning btn-lg rounded-pill px-5"
                      onClick={handleAvailabilityCheck}
                      disabled={isChecking || !fromDate || !selectedLawnType}
                    >
                      {isChecking ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                          ></span>
                          Checking...
                        </>
                      ) : (
                        "Search Slots"
                      )}
                    </button>
                  </div>
                </div>
                {/* Availability Result Section - ONLY SHOW AFTER SEARCH */}
                {availabilityResult && !isChecking && (
                  <div className="mt-5">
                    <div className="mb-4">
                      <h5 className="fw-bold">{selectedLawn?.Lawn_Name}</h5>
                      <p className="text-black text-muted">
                        Guest Capacity: {selectedLawn?.LawnCapacity}
                      </p>
                      <p className="bg-info p-2 text-center small">
                        * Taxes and other charges applicable
                      </p>
                    </div>
                    <div className="mt-4">
                      <h5 className="fw-bold mb-3">Available Time Slots</h5>
                      <p className="text-muted mb-3">
                        Selected Dates:{" "}
                        {bookingDates.map((d) => formatDate(d)).join(", ")}
                      </p>
                      <div className="d-flex flex-wrap gap-3">
                        {availableSlots
                          .filter((slot) => slot.Status !== "Booked")
                          .map((slot) => (
                            <div key={slot.Slot_ID} className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id={`slot-${slot.Slot_ID}`}
                                checked={selectedSlotTypes.includes(
                                  String(slot.Slot_ID)
                                )}
                                onChange={() =>
                                  handleSlotSelect(String(slot.Slot_ID))
                                }
                              />
                              <label
                                className="form-check-label mb-2 ms-2"
                                htmlFor={`slot-${slot.Slot_ID}`}
                              >
                                {slot.Slot_Name || `Slot ${slot.Slot_ID}`}
                              </label>
                            </div>
                          ))}
                      </div>
                    </div>
                    {/* Sundry Items Section */}
                    {sundryTypes.length > 0 && (
                      <div className="mt-4">
                        <h5 className="fw-bold mb-3">Additional Charges</h5>
                        <p className="text-muted mb-3">
                          Select additional charges of miscellaneous services
                        </p>
                        <div className="d-flex flex-wrap gap-3">
                          {sundryTypes.map((sundry) => {
                            const sundryIdStr = String(sundry.LTSundry_ID);
                            const isMandatory =
                              mandatorySundryItems.includes(sundryIdStr);
                            return (
                              <div
                                key={sundry.LTSundry_ID}
                                className="form-check"
                              >
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id={`sundry-${sundry.LTSundry_ID}`}
                                  checked={selectedSundryItems.includes(
                                    sundryIdStr
                                  )}
                                  onChange={() =>
                                    handleSundrySelect(sundryIdStr)
                                  }
                                  disabled={isMandatory}
                                />
                                <label
                                  className="form-check-label mb-2 ms-2"
                                  htmlFor={`sundry-${sundry.LTSundry_ID}`}
                                >
                                  {sundry.LTSundry_Name ||
                                    `Sundry ${sundry.LTSundry_ID}`}{" "}
                                  - ₹{sundry.LTSundry_Amount || 0}
                                </label>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                    <div className="text-center mt-4">
                      {slotError && (
                        <div
                          className="alert alert-danger alert-dismissible fade show mb-3"
                          role="alert"
                        >
                          <i className="bi bi-exclamation-triangle-fill me-2"></i>
                          {slotError}
                          <button
                            type="button"
                            className="btn-close"
                            onClick={() => setSlotError(null)}
                            aria-label="Close"
                          ></button>
                        </div>
                      )}
                      <div className="text-center mt-4">
                        <button
                          className="btn btn-primary btn-lg rounded-pill px-5"
                          onClick={() => {
                            if (selectedSlotTypes.length === 0) {
                              setSlotError(
                                "Please select at least one time slot to continue."
                              );
                              return;
                            }
                            setStep(2);
                          }}
                          disabled={
                            !selectedSlotTypes.length &&
                            !selectedSundryItems.length
                          }
                        >
                          Continue to Booking Details →
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                {/* Show Loading Message During Check */}
                {isChecking && (
                  <div className="text-center mt-4">
                    <div className="spinner-border text-warning" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="text-muted mt-2">Checking availability...</p>
                  </div>
                )}
              </div>
            </div>
          )}
          {/* Step 2: Guest Details */}
          {step === 2 && (
            <div className="row g-4">
              <div className="col-lg-7">
                <div className="card shadow-lg border-0 rounded-4">
                  <div className="card-header bg-gradient-primary py-4">
                    <h4 className="mb-0 text-center">
                      {selectedLawn?.Lawn_Name} Booking Information
                    </h4>
                  </div>
                  <div className="card-body p-4">
                    <div className="mb-4">
                      <h5 className="fw-bold mb-3">Guest Details</h5>
                      {guests.map((g) => (
                        <div key={g.id} className="border rounded p-4 mb-4">
                          <div className="mb-3">
                            <label className="form-label fw-semibold">
                              Booking For
                            </label>
                            <select
                              className="form-select rounded-pill"
                              value={g.bookingFor}
                              onChange={(e) =>
                                handleGuestChange(
                                  g.id,
                                  "bookingFor",
                                  e.target.value
                                )
                              }
                            >
                              <option value="Member">
                                Member ({memberName})
                              </option>
                              <option value="Dependent">Dependent</option>
                              <option value="Guest">Guest</option>
                            </select>
                          </div>
                          {g.bookingFor === "Dependent" && (
                            <div className="mb-3">
                              <label className="form-label fw-semibold">
                                Select Dependent (Optional)
                              </label>
                              <select
                                className="form-select rounded-pill"
                                value={g.dependentId}
                                onChange={(e) =>
                                  handleDependentSelect(g.id, e.target.value)
                                }
                              >
                                <option value="">-- Choose --</option>
                                {dependents.map((d) => (
                                  <option key={d.DeptID} value={d.DeptID}>
                                    {d.Name} ({d.Relation})
                                  </option>
                                ))}
                              </select>
                            </div>
                          )}
                          {g.bookingFor !== "Member" && (
                            <>
                              <div className="mb-3">
                                <label className="form-label fw-semibold">
                                  Full Name
                                </label>
                                <input
                                  type="text"
                                  className="form-control rounded-pill"
                                  value={g.name}
                                  onChange={(e) =>
                                    handleGuestChange(
                                      g.id,
                                      "name",
                                      e.target.value
                                    )
                                  }
                                  placeholder="Enter full name"
                                />
                              </div>
                              <div className="mb-3">
                                <label className="form-label fw-semibold">
                                  Contact (10-digit Indian)
                                </label>
                                <input
                                  type="tel"
                                  className={`form-control rounded-pill ${
                                    /^[6-9]\d{9}$/.test(g.contact)
                                      ? "is-valid"
                                      : g.contact
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  value={g.contact}
                                  onChange={(e) =>
                                    handleGuestChange(
                                      g.id,
                                      "contact",
                                      e.target.value
                                    )
                                  }
                                  placeholder="Enter 10-digit phone number"
                                />
                                {g.contact &&
                                  !/^[6-9]\d{9}$/.test(g.contact) && (
                                    <div className="invalid-feedback d-block">
                                      Must be a valid 10-digit Indian number
                                    </div>
                                  )}
                              </div>
                            </>
                          )}
                          {g.bookingFor === "Member" && (
                            <div className="alert alert-light p-3 small">
                              <i className="bi bi-person me-2"></i>
                              Using member profile:{" "}
                              <strong>{memberName}</strong>, {memberMobile}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                    <div className="d-flex justify-content-between">
                      <button
                        className="btn btn-outline-secondary rounded-pill px-4"
                        onClick={() => setStep(1)}
                      >
                        ← Back
                      </button>
                      <button
                        className="btn btn-success btn-lg rounded-pill px-5"
                        onClick={handleAddToCart}
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                            ></span>
                            Processing...
                          </>
                        ) : (
                          "Add to Cart & Proceed"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
                <div
                  className="card shadow-lg border-0 rounded-4 sticky-top"
                  style={{ top: "20px" }}
                >
                  <div className="card-header bg-gradient-primary py-4">
                    <h4 className="mb-0 text-center">📋 Booking Summary</h4>
                  </div>
                  <div className="card-body p-4">
                    <div className="mb-4">
                      <h5 className="fw-bold">
                        <i className="bi bi-tree me-2"></i>{" "}
                        {selectedLawn?.Lawn_Name}
                      </h5>
                    </div>
                    <ul className="list-unstyled mb-4">
                      <li className="d-flex justify-content-between mb-2">
                        <span className="text-muted">
                          <i className="bi bi-calendar-check me-2"></i>Dates:
                        </span>
                        <span className="fw-semibold">
                          {bookingDates.length > 7
                            ? bookingDates
                                .slice(0, 4)
                                .map((d) =>
                                  new Date(d).toLocaleDateString("en-GB", {
                                    day: "numeric",
                                    month: "short",
                                  })
                                )
                                .join(", ") +
                              " ... " +
                              new Date(
                                bookingDates[bookingDates.length - 1]
                              ).toLocaleDateString("en-GB", {
                                day: "numeric",
                                month: "short",
                              })
                            : bookingDates
                                .map((d) =>
                                  new Date(d).toLocaleDateString("en-GB", {
                                    day: "numeric",
                                    month: "short",
                                  })
                                )
                                .join(", ")}
                        </span>
                      </li>
                      <li className="d-flex justify-content-between mb-2">
                        <span className="text-muted">
                          <i className="bi bi-clock me-2"></i>Slots:
                        </span>
                        <span className="fw-semibold">
                          {selectedSlots.length > 0
                            ? selectedSlots
                                .map((s) => s.Slot_Name || `Slot ${s.Slot_ID}`)
                                .join(", ")
                            : "None selected"}
                        </span>
                      </li>
                      <li className="d-flex justify-content-between mb-2">
                        <span className="text-muted">
                          <i className="bi bi-people me-2"></i>Guests:
                        </span>
                        <span className="fw-semibold">{numPeople}</span>
                      </li>
                      <li className="d-flex justify-content-between mb-2">
                        <span className="text-muted">
                          <i className="bi bi-person me-2"></i>Booking For:
                        </span>
                        <span className="fw-semibold">
                          {guests[0]?.bookingFor || "Member"}
                        </span>
                      </li>
                    </ul>
                    <div className="p-3 bg-light rounded mb-4">
                      <h5 className="fw-bold mb-3">
                        <i className="bi bi-receipt me-2"></i>Price Breakdown
                      </h5>
                      {/* Base Lawn Price */}
                      <div className="d-flex justify-content-between mb-2">
                        <span>Base Amount ({numPeople} guests)</span>
                        <span>₹{prices.base.toFixed(2)}</span>
                      </div>
                      {/* Sundry Items */}
                      {selectedSlotTypes.map((slotId) => {
                        const isSundryItem = sundryTypes.some(
                          (s) => String(s.LTSundry_ID) === slotId
                        );
                        if (isSundryItem) {
                          const sundry = sundryTypes.find(
                            (s) => String(s.LTSundry_ID) === slotId
                          );
                          return (
                            <div
                              key={slotId}
                              className="d-flex justify-content-between mb-2"
                            >
                              <span>
                                {sundry?.LTSundry_Name || `Sundry ${slotId}`}
                              </span>
                              <span>₹{sundry?.LTSundry_Amount || 0}</span>
                            </div>
                          );
                        }
                        return null;
                      })}
                      {/* Selected Sundry Items */}
                      {selectedSundryItems.map((sundryId) => {
                        const sundry = sundryTypes.find(
                          (s) => String(s.LTSundry_ID) === sundryId
                        );
                        return (
                          <div
                            key={sundryId}
                            className="d-flex justify-content-between mb-2"
                          >
                            <span>
                              {sundry?.LTSundry_Name || `Sundry ${sundryId}`}
                            </span>
                            <span>₹{sundry?.LTSundry_Amount || 0}</span>
                          </div>
                        );
                      })}
                      {taxIncluded ? (
                        <>
                          <div className="d-flex justify-content-between mb-2">
                            <span>
                              CGST ({(taxPercentage * 0.5).toFixed(1)}%)
                            </span>
                            <span className="text-success">
                              + ₹{(totalPrice.tax * 0.5).toFixed(2)}
                            </span>
                          </div>
                          <div className="d-flex justify-content-between mb-2">
                            <span>
                              SGST ({(taxPercentage * 0.5).toFixed(1)}%)
                            </span>
                            <span className="text-success">
                              + ₹{(totalPrice.tax * 0.5).toFixed(2)}
                            </span>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="d-flex justify-content-between mb-2">
                            <span>
                              CGST ({(taxPercentage * 0.5).toFixed(1)}%)
                            </span>
                            <span className="text-success">
                              + ₹{(totalPrice.tax * 0.5).toFixed(2)}
                            </span>
                          </div>
                          <div className="d-flex justify-content-between mb-2">
                            <span>
                              SGST ({(taxPercentage * 0.5).toFixed(1)}%)
                            </span>
                            <span className="text-success">
                              + ₹{(totalPrice.tax * 0.5).toFixed(2)}
                            </span>
                          </div>
                        </>
                      )}
                      <hr className="my-3" />
                      <div className="d-flex justify-content-between mb-2">
                        <span>Total (Per Day)</span>
                        <span>₹{totalPrice.total.toFixed(2)}</span>
                      </div>
                      <div className="d-flex justify-content-between fw-bold mb-2">
                        <span>Total for {bookingDates.length} Day(s)</span>
                        <span>
                          ₹{(totalPrice.total * bookingDates.length).toFixed(2)}
                        </span>
                      </div>
                    </div>
                    <div className="alert alert-info small p-3">
                      <small className="text-muted">
                        Booking is refundable according to the applicable
                        cancellation policy.
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LawnBooking;
